import React from "react";

import fields from "./fields";
import propTypes from "../../../../constants/propTypes";
import { FormPageSection } from "../../../layout/FormPageSection";
import withLabeledTextOption from "../../../../withPORevision/withLabeledTextOption";
import { useTimezone } from "../../../../contexts/TimezoneContext";

const QuoteSection = ({ purchaseOrder, freightVendor, ...formikProps }) => {
  // Get timezone from TimezoneContext (set at PurchaseOrderDetailContainer level)
  const timezone = useTimezone();

  return (
    <FormPageSection
      fields={fields(purchaseOrder, timezone)}
      headerText="Quote Details"
      {...formikProps}
    />
  );
};

QuoteSection.propTypes = {
  purchaseOrder: propTypes.purchaseOrder,
  freightVendor: propTypes.vendor,
};

export default withLabeledTextOption(QuoteSection);
